import useNamespacedLocalStorage, { getNamespacedLocalStorageKey } from 'app/hooks/useNamespacedLocalStorage';

export const PERSISTED_SEARCH_KEY = 'ostroPersistedSearch';

export default function usePersistedSearch() {
  return useNamespacedLocalStorage(PERSISTED_SEARCH_KEY, '');
}

export function getPersistedSearch() {
  return getNamespacedLocalStorageKey(PERSISTED_SEARCH_KEY);
}
